import React from "react";

import ModalTabContent from "../../components/modal/ModalTabContent";
import SettingsDateGroup from "./SettingsDateGroup";

const SettingsRangeTab = props => {
  return (
    <ModalTabContent>
      <SettingsDateGroup {...props} />
    </ModalTabContent>
  );
};

export default SettingsRangeTab;
